import { Component, OnInit, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';
import { Configuracion } from '../../configuracion/configuracion.model';
import { DialogService } from '../modals/dialog.service';
import { CambioDolarVenta } from '../../configuracion/cambioDolarVenta.model';
import { RangoFecha } from '../../acuerdo/rango-fecha.model';
import { Cotizacion } from '../cotizacion/cotizacion.model';
import { Router } from '../../../../node_modules/@angular/router';

@Component({
  selector: 'app-cambio-dolar-venta',
  templateUrl: './cambio-dolar-venta.component.html',
  styleUrls: ['./cambio-dolar-venta.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CambioDolarVentaComponent implements OnInit  {

  @Input() cotizacion: Cotizacion;
  @Output() onUpdateDolarVenta = new EventEmitter<boolean>();
  staticCambioDolarVenta = { valor: null };
  operationalCambioDolarVenta = { valor: null };

  staticDolaresVenta: Configuracion[];
  isLoading: boolean;
  fechaDesde: Date;
  fechaHasta: Date;
  currentDate = new Date();

  validDates = [];
  maximoHasta: string;
  private rangoFecha: RangoFecha;
  private rangoHabil: RangoFecha;

  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  constructor(
    private backendService: BackendService,
    private snackService: SnackService,
    private dialogService: DialogService,
    private router: Router
  ) { }

  hasCambioDolarVenta() {
    if (this.staticCambioDolarVenta.valor !== null) {
      return true;
    }
    return false;
  }

  async confirmCambioDolarVenta() {
      this.dialogService.confirm('Modificar cotización dolar',
      '¿Está seguro que desea modificar la cotización actual de venta del dólar?')
      .then( res => {
        if (res) {
          this.save(res);
        }
      });
  }

  async save(res) {
    if (res) {
      /*this.rangoFecha.fechaDesde = null;
      this.rangoFecha.fechaHasta = null;
      await this.comprobarFechas();*/
      //if (this.rangoHabil.habil) {
        this.snackService.spinner(true);
        try {
          if (!this.cotizacion) {
            await this.backendService.changeDolarVenta('/configuraciones/cambio_dolar_venta?dolar='
                                                        + this.operationalCambioDolarVenta.valor, this.rangoFecha);
            await     this.backendService.getDolarVenta('/configuraciones/dolar_venta').then(
              data => {
                this.staticCambioDolarVenta.valor = data;
              }
            );
            this.onUpdateDolarVenta.emit(true);
            //await this.getFechasOcupadas();
          } else {
            this.cotizacion.desdeString = this.rangoFecha.fechaDesde;
            this.cotizacion.hastaString = this.rangoFecha.fechaHasta;
            this.cotizacion.valor = this.operationalCambioDolarVenta.valor;
            await this.backendService.update(Cotizacion.path, this.cotizacion);
            this.router.navigate(['/cotizacion']);
          }
          this.snackService.success('Cotización actualizada');
          this.snackService.spinner(false);
        } catch (error) {
          this.snackService.spinner(false);
          this.snackService.error(error.message);
        }
      /*} else {
        this.snackService.error('El rango seleccionado no esta habilitado.');
      }*/
    }
  }

  async ngOnInit() {
    /*if (this.cotizacion) {
      this.operationalCambioDolarVenta.valor = this.cotizacion.valor;
      this.fechaDesde = new Date(this.cotizacion.desde);
      this.fechaHasta = new Date(this.cotizacion.hasta);
    }*/
    this.backendService.getDolarVenta('/configuraciones/dolar_venta').then(
      res => {
        this.staticCambioDolarVenta.valor = res;
      }
    );
    /*this.rangoFecha = this.backendService.new(RangoFecha);
    await this.getFechasOcupadas();*/
  }

  /*async comprobarFechas() {
    if (this.fechaDesde) {
      this.rangoFecha.fechaDesde = this.fechaDesde.toISOString();
    }
    if (this.fechaHasta) {
      this.rangoFecha.fechaHasta = this.fechaHasta.toISOString();
    }
    await this.backendService.getRangoFecha(Cotizacion.path + 'fechas-acuerdos/'
      + (this.cotizacion ? this.cotizacion.id : 0), this.rangoFecha)
    .then(data => {
      this.rangoHabil = data as RangoFecha;
    });
  }

  async getFechasOcupadas() {
    await this.backendService.getBoolean(Cotizacion.path + 'fechas-ocupadas').then( data => {
      this.validDates = data;
    });
  }

  async getRango() {
    let i = 0 ;
    while ( i < 90) {
      this.maximoHasta = '';
      const fechaSiguiente = new Date(this.fechaDesde);
      fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
      if (this.validDates[fechaSiguiente.toISOString()]) {
        this.maximoHasta = fechaSiguiente.toISOString();
        return;
      } else {
        i++;
      }
    }
  }

  async rangoReverso() {
    let i = 0 ;
    if (!this.fechaDesde) {
      while ( i < 90) {
        const fechaAnterior = new Date(this.fechaHasta);
        fechaAnterior.setDate(fechaAnterior.getDate() - i);
        if (this.validDates[fechaAnterior.toISOString()]) {
          fechaAnterior.setDate(fechaAnterior.getDate() + 1);
          this.fechaDesde = fechaAnterior;
          return;
        } else {
          i++;
        }
      }
    } else { return; }
  }

  eliminarCambioDolarVenta() {
    this.dialogService.confirm('Eliminar cotización dolar',
    '¿Está seguro que desea eliminar la cotización de venta del dólar?')
    .then( async res => {
      if (res) {
        try {
          this.snackService.spinner(true);
          await this.backendService.delete(Cotizacion.path + this.cotizacion.id);
          this.router.navigate(['/cotizacion']);
          this.snackService.success('Cotización actualizada');
          this.snackService.spinner(false);
        } catch (error) {
          this.snackService.spinner(false);
          this.snackService.error(error.message);
        }
      }
    });
  }*/
}



// WEBPACK FOOTER //
// ./src/app/shared-components/cambio-dolar-venta/cambio-dolar-venta.component.ts